jQuery('.home-product-list').slick({
  infinite: true,
  cssEase: 'linear',
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  autoplaySpeed: 2000,
  autoplay: true,
  swipeToSlide: true,
  nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0602/4904/7239/files/Arrow-right.png?v=1655965365" class="slick-next">',
  prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0602/4904/7239/files/Arrow-left.png?v=1655965354" class="slick-prev">',
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    }

  }, {
    breakpoint: 800,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
    }
  },  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    }
  }]
});




      jQuery('.related-products .grid--uniform').slick({
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: false,
        arrows: true,
        nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0602/4904/7239/files/Arrow-right.png?v=1655965365" class="slick-next">',
        prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0602/4904/7239/files/Arrow-left.png?v=1655965354" class="slick-prev">',
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
             arrows: false
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });


      jQuery('.product-media-modal__content').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0602/4904/7239/files/Arrow-right.png?v=1655965365" class="slick-next">',
        prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0602/4904/7239/files/Arrow-left.png?v=1655965354" class="slick-prev">',
         responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
             arrows: false
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
